<template>
  <div class="container page" style="background: #000000;">
    <van-nav-bar :title="$t('my.account_detail')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="topInfo">
            <span class="type">{{ typeText(v) }}</span>
            <span :class="['money', Number(v.money) >= 0 ? 'plus' : 'minus']">
              {{ moneyText(v) }}
            </span>
          </div>
          <div class="desc" v-if="v.desc">
            <span>{{ $t("withdraw.desc") }}：{{ v.desc }}</span>
          </div>
          <div class="time">
            <span>{{ $t("withdraw.submit_time") }}：{{ v.create_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    typeText(v) {
      const t = Number(v && v.type);
      if (t === 1) return this.$t("recharge.recharge");
      if (t === 2) return this.$t("recharge.bonus");
      return this.$t("my.account_detail");
    },
    moneyText(v) {
      if (v && v.money_text) return v.money_text;
      const n = Number(v && v.money);
      if (Number.isNaN(n)) return v && v.money;
      return (n > 0 ? "+" : "") + n;
    },
    onRefresh() {
      this.getUserRechargeList().finally(() => {
        this.isLoading = false;
        this.$toast(this.$t("reservation.refresh"));
      });
    },
    normalizeList(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "object") return Object.keys(raw).map((k) => raw[k]);
      return [];
    },
    getUserRechargeList() {
      return this.$http({
        method: "get",
        url: "user_get_recharge_list",
      })
        .then((res) => {
          if (res && res.code === 200) {
            this.list = this.normalizeList(res.data);
          } else if (res && res.code === 401) {
            this.list = [];
            this.$toast(res.msg);
          } else {
            this.list = [];
          }
        })
        .catch(() => {
          this.list = [];
        });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserRechargeList();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main {
  position: relative;
  overflow: auto;
  background-color: #000000;
  height: 100%;
  padding: 0 10px;
}
.item_list {
  padding: 24px;
  margin: 20px 14px;
  background: #141414;
  border-radius: 16px;
  line-height: 60px;
  color: #c9a84c;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}
.item_list .topInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.item_list .topInfo .type {
  font-size: 32px;
  font-weight: 700;
  color: #c9a84c;
}
.item_list .topInfo .money {
  font-size: 32px;
  font-weight: 700;
}
.item_list .topInfo .money.plus {
  color: #07c160;
}
.item_list .topInfo .money.minus {
  color: #ee0a24;
}
.item_list .desc span,
.item_list .time span {
  font-size: 25px;
  font-weight: 500;
  color: #666;
}
</style>
